import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../client/components/ui/accordion";
import useTranslation from "../../client/hooks/useTranslation";
import SectionTitle from "./SectionTitle";
import ScrollAnimation from "./ScrollAnimation";

interface FAQ {
  id: number;
  question: string;
  answer: string;
  href?: string;
}

export default function FAQ({ faqs }: { faqs: FAQ[] }) {
  const t = useTranslation();
  return (
    <div id="faq" className="mx-auto mt-12 max-w-4xl px-6 pb-8 sm:pb-12 sm:pt-8 lg:max-w-7xl lg:px-8 lg:py-16">
      <ScrollAnimation direction="up">
        <SectionTitle
          title={t.landing.faq.title}
          description={t.landing.faq.description}
        />
      </ScrollAnimation>

      <ScrollAnimation direction="up" delay={100}>
        <Accordion type="single" collapsible className="w-full space-y-4">
        {faqs.map((faq) => (
          <AccordionItem
            key={faq.id}
            value={`faq-${faq.id}`}
            className="border-border hover:bg-muted/20 rounded-lg border px-6 py-2 transition-all duration-200"
          >
            <AccordionTrigger className="text-foreground hover:text-primary text-left text-base font-semibold leading-7 transition-colors duration-200">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground">
              <div className="flex flex-col items-start justify-between gap-4">
                <p className="text-muted-foreground flex-1 text-base leading-7">
                  {faq.answer}
                </p>
                {faq.href && (
                  <a
                    href={faq.href}
                    className="text-primary hover:text-primary/80 flex-shrink-0 whitespace-nowrap text-base font-medium leading-7 transition-colors duration-200"
                  >
                    Learn more →
                  </a>
                )}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
        </Accordion>
      </ScrollAnimation>
    </div>
  );
}
